import React from "react";

const data = [

{ name:"Rahul", workload:5 },
{ name:"Neha", workload:3 },
{ name:"Aman", workload:7 },
{ name:"Priya", workload:2 }

];

const DesignerHeatmap = () => (

<div className="card shadow-sm">

<div className="card-body">

<h5>Workload Heatmap</h5>

<div className="row">

{data.map((d,i)=>(

<div className="col-md-6 mb-3" key={i}>

<div
style={{
background:d.workload>5?"#ff6b6b":
d.workload>3?"#feca57":"#1dd1a1",
color:"white",
padding:"20px",
borderRadius:"8px",
textAlign:"center"
}}
>

<h6>{d.name}</h6>
<p>{d.workload} active cases</p>

</div>

</div>

))}

</div>

</div>

</div>

)

export default DesignerHeatmap